import createReactComponent from '../createReactComponent';
export default createReactComponent('aspect-ratio-off', 'IconAspectRatioOff', [
  [
    'path',
    {
      d: 'M9 5h10a2 2 0 0 1 2 2v10m-2 2h-14a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2',
      key: 'svg-0',
    },
  ],
  ['path', { d: 'M7 12v-3h2', key: 'svg-1' }],
  ['path', { d: 'M17 12v1m-2 2h-1', key: 'svg-2' }],
  ['path', { d: 'M3 3l18 18', key: 'svg-3' }],
]);
